import { entries, keys } from "lodash";
import { Frequency } from "PFApp/analytics/types/export_analytics";
import { useExportFields } from "PFCore/hooks/queries/analytics/booking_export/use_export_fields";
import { useMemo } from "react";

import { useAnalyticsModalContext } from "../analytics_modal_context_provider";

const STANDARD_FIELDS_PREFIX = "standardFields";

export const useRequiredFields = () => {
  const { data } = useExportFields();
  const {
    state: {
      data: { frequency }
    }
  } = useAnalyticsModalContext();
  const fieldsKeys = useMemo(
    () =>
      entries(data?.entries || {})
        .flatMap(([key, value]) => {
          if (key === STANDARD_FIELDS_PREFIX) {
            return keys(value);
          }
        })
        .filter(Boolean),
    [data]
  );

  const keysPerFreqency = useMemo(
    () => ({
      [Frequency.Daily]: [
        ...(fieldsKeys.includes("profileId") ? ["profileId"] : []),
        ...(fieldsKeys.includes("date") ? ["date"] : [])
      ],
      [Frequency.Weekly]: [
        ...(fieldsKeys.includes("profileId") ? ["profileId"] : []),
        ...(fieldsKeys.includes("weekNo") ? ["weekNo"] : []),
        ...(fieldsKeys.includes("weekStart") ? ["weekStart"] : [])
      ],
      [Frequency.Monthly]: [
        ...(fieldsKeys.includes("profileId") ? ["profileId"] : []),
        ...(fieldsKeys.includes("monthNo") ? ["monthNo"] : []),
        ...(fieldsKeys.includes("monthStart") ? ["monthStart"] : []),
        ...(fieldsKeys.includes("monthName") ? ["monthName"] : [])
      ]
    }),
    [fieldsKeys]
  );

  return {
    requiredKeys: keysPerFreqency[frequency]
  };
};
